import { PageHeader } from '@/components/layout/page-header';
import { MessagesPanel } from '@/features/notifications/messages-panel';

const UserNotificationsPage = () => (
  <div className="flex flex-col gap-4">
    <PageHeader title="User Notifications" />
    <MessagesPanel />
  </div>
);
UserNotificationsPage.displayName = 'UserNotificationsPage';

export default UserNotificationsPage;
